import type { OnboardingItem, ProjectTask } from '../types';
import { isOnboardingBridgeTaskId } from './onboardingTaskBridge';

export type PmDateReviewFields = Pick<
  ProjectTask,
  'id' | 'scheduleNeedsPmReview' | 'scheduleReviewedByPmAt' | 'scheduleReviewedByPmUid'
>;

/** Generated checklist rows, or any row stamped at contract generation. */
export function isGeneratedScheduleTask(task: Pick<PmDateReviewFields, 'id' | 'scheduleNeedsPmReview'>): boolean {
  if (task.scheduleNeedsPmReview === true) return true;
  if (task.scheduleNeedsPmReview === false) return false;
  return isOnboardingBridgeTaskId(task.id);
}

/** Yellow calendar: generated dates that the assigned PM has not confirmed yet. */
export function taskNeedsPmDateReview(task: PmDateReviewFields): boolean {
  if (task.scheduleReviewedByPmAt) return false;
  return isGeneratedScheduleTask(task);
}

export type PmDateReviewStamp = {
  scheduleReviewedByPmAt: Date;
  scheduleReviewedByPmUid: string;
  scheduleNeedsPmReview: false;
};

/**
 * Stamp only when the actor is the project's assigned project manager.
 * Designation alone is not enough.
 */
export function pmDateReviewStamp(
  assignedPmUid: string | undefined,
  actorUid: string | undefined,
): PmDateReviewStamp | null {
  const assigned = assignedPmUid?.trim();
  const actor = actorUid?.trim();
  if (!assigned || !actor || assigned !== actor) return null;
  return {
    scheduleReviewedByPmAt: new Date(),
    scheduleReviewedByPmUid: actor,
    scheduleNeedsPmReview: false,
  };
}

export function mergePmDateReviewIntoTaskPatch(
  patch: Partial<ProjectTask>,
  assignedPmUid: string | undefined,
  actorUid: string | undefined,
): Partial<ProjectTask> {
  if (patch.startDate === undefined && patch.endDate === undefined) return patch;
  const stamp = pmDateReviewStamp(assignedPmUid, actorUid);
  return stamp ? { ...patch, ...stamp } : patch;
}

export function mergePmDateReviewIntoOnboardingPatch(
  patch: Partial<OnboardingItem>,
  assignedPmUid: string | undefined,
  actorUid: string | undefined,
): Partial<OnboardingItem> {
  if (patch.startDate === undefined && patch.endDate === undefined) return patch;
  const stamp = pmDateReviewStamp(assignedPmUid, actorUid);
  return stamp ? { ...patch, ...stamp } : patch;
}
